<template>
  <div>
    <el-dialog :title="title" :visible="localVisible" width="70%" @close="onClose">
      <el-form label-width="110px" :inline="true" size="mini">
            <el-form-item >
              <el-input v-model="keywords" clearable placeholder="司机姓名/手机号"></el-input>
            </el-form-item>
           <el-form-item>
            <el-button @click="chooseItem">查询</el-button>
            </el-form-item>
      </el-form>
      <div>
        <el-table
          ref="multipleTable"
          :data="mList"
          height="300"
          stripe
          border
          size="mini"
          :header-cell-style="{background:'#e5e5e5',color:'#333333'}"
        >
           <el-table-column label="" width="50" align="center">
            <template slot-scope="scope">
              <el-radio v-model="curShop" :label="scope.row" @input="clickChange(scope.row,scope.$index)">{{ "" }}</el-radio>
            </template>
          </el-table-column>
          <el-table-column
                  label="电话"
                  width="100"
                  prop="tel"
                  :show-overflow-tooltip='true'
          >
          </el-table-column>
          <el-table-column
                  label="编码"
                  width="100"
                  prop="sn"
                  :show-overflow-tooltip='true'
          >
          </el-table-column>

          <el-table-column
            label="姓名"
            width="100"
            prop="name"
            :show-overflow-tooltip='true'
          >
          </el-table-column>


          <el-table-column
            label="注册日期"
            width="200"
            prop="mobile"
            :show-overflow-tooltip='true'
          >
          </el-table-column>
        </el-table>
        <div class="block" style="margin-top:10px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[10, 20, 30, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>s
        <el-row>
          <el-col style="padding-top: 10px;display:flex;flex-direction: row;justify-content: flex-end;">
            <el-button size="mini" @click="close">取消</el-button>
            <el-button  size="mini" type="primary" @click="ok">确定</el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    name:'eOwnerList',
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      formData: {
        type: Object,
        default: null
      },
      title: {
        type: String,
        default: "",
      },
      closeForm: Function,
    }
    ,
    data(){
      return {
        localVisible:false,
        index:'',
        curShop:'',
        id:'',
        name:'',
        keywords:'',
        fileList:[],
        mList:[],
        pageNum:1,
        pageSize:10,
        total:0,
        item:{}
      }
    },
    mounted() {
      this.DataList();
    },
    methods:{
      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.pageNum = newPage
        this.DataList()
      },
      onClose(){
        this.$emit('update:visible',false)
        this.closeForm();
      },
      close(){
        this.$emit('update:visible',false)
        this.closeForm();
      },
      ok(){
        this.$emit('eventChoose',this.id,this.name,this.item);
        this.$emit('update:visible',false)
        this.closeForm();
      },
      DataList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          pageNum: this.pageNum,
          pageSize: this.pageSize,

        }
        if(this.keywords){
          param.keyword=this.keywords;
        }
        this.$axios.findOwnerByLgsListP(param).then(res=>{
          if(res.code == 200){
            this.mList = res.data.data
            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      clickChange(row,index){
        this.index=index;
        this.id=row.id;
        this.name=row.name;
        // this.formData.name=row.name;
        // this.formData.id=row.id;
        this.item=this.mList[index];
        console.log('row----',row);
      },
      handleBeforeUpload(){

      },
      uploadSuccess(){

      },
      uploadFile(){

      },
      chooseItem(){
        this.mList=[];
        this.total=0;
        this.pageNum=1;
        this.DataList();
      }
    },
    // 监听
    watch: {
      visible(val) {
        this.localVisible=val;
        if (val) {
          // if (this.formData.img) {
          //   console.log(this.formData, " this.formData");
          //   this.formData.img = [
          //     {
          //       name: this.formData.img,
          //       url: this.formData.img,
          //     },
          //   ];
          // }
        }
      },
    },
  }
</script>
<style lang="less" scoped>
  //https://www.yzktw.com.cn/post/1262748.html
  .upload_group {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .upload_list {
      width: 120px;
      margin-right: 1rem;
    }

    /deep/.el-upload-dragger .el-upload__text {
      font-size: 10px;
      color: #409EFF;
    }

    /deep/.el-icon-upload:before {
      width: 40px !important;
      height: 40px !important;
    }

    .upload_list:last-child {
      margin-right: 0;
    }

    /deep/.el-upload-dragger {
      width: 100%;
      height: auto;
      padding: 20px 0;
      border: 1px solid #999;
    }

    /deep/.el-upload {
      width: 100%;
    }

    /deep/.el-upload-dragger .el-icon-upload {
      margin: 10px 0;
    }
  }
  .table_name:hover{
    color: #409EFF;
    cursor: pointer;
  }
</style>
